/**
 * Truncate `text` to `maxWords` words, preferring to end at the next sentence
 * boundary within a small look-ahead window. Returns the display string and a
 * flag indicating whether truncation occurred (used to decide whether to show
 * a "Read more" link).
 */
export function truncateToWords(
  text: string,
  maxWords: number,
): { display: string; isTruncated: boolean } {
  const trimmed = text.trim();
  const words = trimmed.split(/\s+/);
  if (words.length <= maxWords) return { display: trimmed, isTruncated: false };

  // Walk to the character index after the maxWords-th word.
  let pos = 0;
  for (let i = 0; i < maxWords; i += 1) {
    const word = words[i] ?? '';
    const found = trimmed.indexOf(word, pos);
    if (found < 0) break;
    pos = found + word.length;
  }

  // Extend up to 80 chars forward to land on a sentence boundary.
  const lookAhead = trimmed.slice(pos, pos + 80);
  const sentenceEnd = lookAhead.search(/[.!?]/);
  if (sentenceEnd >= 0) {
    return { display: trimmed.slice(0, pos + sentenceEnd + 1), isTruncated: true };
  }
  // Fall back to ellipsis at the word boundary.
  return { display: trimmed.slice(0, pos).replace(/[,;:]+$/, '') + '…', isTruncated: true };
}
